module.exports = __webpack_public_path__ + "assets/adpoly-it-idf-rooms-bulk-upload-template.de9436e6.xlsx";